import React from "react";
import "./OurVision.css";

const OurVision = () => {
  return (
    <section className="ourvision-section">
      <div className="ourvision-overlay"></div>

      <div className="ourvision-container">
        <div className="ourvision-heading">
          <h2>
            <span className="mission">Mission:</span> Shaping Futures with
            Purpose.
          </h2>
          <h2>
            <span className="vision">Vision:</span> A World Where Every Fresher
            Gets a Fair Start.
          </h2>
        </div>

        <p className="ourvision-text">
          We believe every fresher deserves an equal chance to shine —
          regardless of their background or network. Our mission is to bridge
          the gap between <strong>talent and opportunity</strong>
          by mentoring students with the right{" "}
          <strong>knowledge, confidence,</strong> and
          <strong> career tools</strong> that make them industry-ready.
          <br />
          <br />
          At <strong>MBR Network’s</strong>, we don’t just train —
          <span className="highlight">
            {" "}
            we transform learners into professionals.
          </span>
          Through real-world mentorship, mock interviews, resume-building
          workshops, and one-on-one career mapping sessions, we’ve helped
          hundreds of students
          <strong> land internships, job offers,</strong> and{" "}
          <strong>build clarity</strong>
          in their career path.
          <br />
          <br />
          Every program, webinar, and interaction at MBR Network’s is designed
          with one goal:
          <span className="trust">
            {" "}
            to make every fresher believe — “Yes, I can make it.”
          </span>
        </p>

        <div className="ourvision-stats">
          <div className="stat-card">
            <h3>500+</h3>
            <p>Students Mentored</p>
          </div>
          <div className="stat-card">
            <h3>50+</h3>
            <p>Successful Placements</p>
          </div>
          <div className="stat-card">
            <h3>100+</h3>
            <p>Workshops & Sessions</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurVision;
